module.exports = __webpack_public_path__ + "media/clouds.18a99d4e.mp4";